import React, { useEffect, useState } from 'react';
import ReactLeafletKmz from '../leaflet_plugins/ReactLeafletKmz';

// const initPath = process.env.REACT_APP_URL;

export default function Jtwc() {
  const [storm, setStorm] = useState([]);

  useEffect(() => {
    // console.log("initPath : ", initPath);
    function fetchJtwc() {
      fetch('https://www.metoc.navy.mil/jtwc/rss/jtwc.rss')
      // fetch(`${initPath}/uploads/storm_name_rss.xml`)
        .then((response) => response.text())
        .then((str) => new window.DOMParser().parseFromString(str, 'text/xml'))
        .then((data) => {
          // console.log(`Raw Data : ${data}`);

          // find item tags
          const items = data.querySelectorAll('item');

          // loop through item tag and get description element
          let matchesAll = [];

          items.forEach((el) => {
            // console.log(`Description : ${el.querySelector('description').innerHTML}`);
            const desc = el.querySelector('description').innerHTML;

            // find .kmz filename in description, if available
            const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
            const matches = desc.match(expression);

            if (matches != null) {
              matchesAll = matchesAll.concat(matches);
            }
          });

          // console.log('---- URLs Found ----');
          // console.log(`Match URL : ${matchesAll}`);

          // find url that match wp... and io...
          const stormCurrent = matchesAll.filter((url) => url.includes('.kmz') && (url.includes('/wp') || url.includes('/io')));

          // console.log('---- Storm in pacific and indian ocean ----');
          // console.log(`Current Storm - ${stormCurrent}`);
          const stormUrlValue = [];
          if (stormCurrent.length > 0) {
            stormCurrent.map((stormUrl) => stormUrlValue.push(`proxy/kmz.php?file=${stormUrl}`));
            // stormCurrent.map((stormUrl) => setStorm([`http://localhost:3000/one_map/proxy/kmz.php?file=${stormUrl}`]));
          }
          setStorm(stormUrlValue);
        });
    }

    fetchJtwc();
  }, [setStorm]);

  return (
    <>
      {/* {console.log(storm)} */}
      {storm.map((d) => <ReactLeafletKmz key={d} url={d} />)}
    </>
  );
}
